import emptyStateLogo from '@/assets/empty_state.svg';

interface EmptyPlaceholderProps {
  title?: string;
  description?: string | boolean;
  logo?: string;
  logoAlt?: string;
  className?: string;
}

export const EmptyPlaceholder = ({
  title,
  description,
  logo = emptyStateLogo,
  logoAlt = 'Empty State Logo',
  className = '',
}: EmptyPlaceholderProps) => {
  return (
    <div className={`flex flex-1 w-full items-center flex-col justify-center h-full ${className}`}>
      <div className="flex justify-center mb-4">
        <img src={logo} alt={logoAlt} className="h-32 w-auto" />
      </div>
      {title && <div className="text-lg">Tidak ada data {title}.</div>}
      {description && <div className="text-gray-500">{description}</div>}
    </div>
  );
};

export default EmptyPlaceholder;
